import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=9b8a2a36"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=9b8a2a36&prod&lang=scss"
import style1 from "./Index.vue?vue&type=style&index=1&id=9b8a2a36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports